<template>
  <v-layout wrap id="calls-list">
    <v-flex xs12>
      <v-btn
        large
        block
        dark
        color="green darken-4"
        v-if="isOnline"
        @click="refreshCalls"
        :loading="loading"
      >
        <v-icon dark>refresh</v-icon>
        {{ $vuetify.t('$vuetify.calls.refreshCalls') }}
      </v-btn>
      <v-btn large block dark color="red darken-4" v-else>
        <v-icon dark style="width:30px">wifi_off</v-icon>
        Offline
      </v-btn>
    </v-flex>

    <v-flex xs12 v-if="sortAndFilter(this.calls).length === 0">
      <v-card>
        <v-card-title>
          {{ $vuetify.t('$vuetify.calls.noAssignments') }}
        </v-card-title>
      </v-card>
    </v-flex>

    <v-flex xs12 v-for="call in sortAndFilter(this.calls)" :key="call.id">
      <v-card
        :to="{ name: 'callDetail', params: { id: call.id } }"
        :key="call.id"
        :color="callBG(call.status).background"
        :class="callBG(call.status).class"
        raised
        tile
      >
        <v-card-title :class="callBG(call.status).header">
          {{ call.company }}
          <v-spacer></v-spacer>
          <v-icon color="yellow" v-if="call.is_new">star</v-icon>
        </v-card-title>

        <v-card-text class="call" :status="call.status" :id="call.id">
          <div class="text-xs-left call-description blue-grey--text">
            <strong>{{ $vuetify.t('$vuetify.calls.callRef') }}:</strong>
            {{ call.call_remote_id }}
            &nbsp;&nbsp;&nbsp;&nbsp;

            <strong>{{ $vuetify.t('$vuetify.calls.postcode') }}:</strong>
            {{ call.postcode }}
          </div>

          <div class="text-xs-left call-description blue-grey--text">
            <strong>{{ $vuetify.t('$vuetify.calls.scheduledDate') }}:</strong>
            {{ formatDatetimeWithoutTimeZone(call.scheduled_at) }}
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import formatting from '../mixins/formatting.js'

export default {
  name: 'CallsList',
  mixins: [formatting],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      arrived: 'calls/arrived',
      readCalls: 'calls/readCalls',
      geoCodeAddress: 'location/geoCodeAddress',
      refreshUserCalls: 'calls/refreshUserCalls'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    callBG: function(type) {
      switch (type) {
        case 'Available':
          return {
            background: 'green lighten-5',
            class: 'black--text my-2 tile',
            header: 'green lighten-1 font-weight-bold',
            footer: 'green lighten-3'
          }
        case 'Accepted':
          return {
            background: 'orange lighten-5',
            class: 'black--text my-2 tile',
            header: 'orange lighten-3 font-weight-bold',
            footer: 'orange lighten-3'
          }
      }
    },

    refreshCalls() {
      this.loading = true
      this.refreshUserCalls()
        .then(r => {
          this.readCalls({ force: true }).then(calls => {
            const callsCount = calls.data.data.length
            if (this.calls.length > callsCount) {
              if (this.calls.length - callsCount == 1) {
                this.setNotification('1 new call added')
              } else {
                this.setNotification(
                  this.calls.length - callsCount + ' new calls added'
                )
              }
            }
          })
        })
        .then(() => {
          this.loading = false
        })
    },

    sortAndFilter(calls) {
      return _.chain(calls)
        .filter(function(c) {
          return c.status === 'Available' || c.status === 'Accepted'
        })
        .sortBy('call_remote_id')
        .sortBy('status')
        .sortBy(function(d) {
          if (d.scheduled_at === null) {
            return '2099-01-01 00:00:00'
          }
          return d.scheduled_at
        })
        .value()
    }
  },
  computed: {
    ...mapState({
      calls: state => state.calls.list
    }),

    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      userHasActiveCall: 'calls/hasActiveCall'
    }),

    hasActiveCalls() {
      return this.userHasActiveCall(this.$route.params.id)
    },

    callDetail() {
      return this.calls.find(call => call.id === this.activeCallId)
    }
  },
  mounted() {
    this.refreshCalls()
  }
}
</script>

<style scoped lang="scss">
#calls-list .v-card {
  margin-top: 0 !important;
}

.call-description {
  font-size: 14px;
}

.acceptedCall {
  background-color: blue-lighten-2;
}

.availableCall {
  background-color: green;
}

.arrivedPanel {
  background-color: blue darken-2;
  margin-top: 15px;
  margin-bottom: 30px;
  cursor: not-allowed;
}

.travellingPanel {
  background-color: grey darken-2;
  margin-top: 15px;
  margin-bottom: 30px;
  cursor: pointer;
}
</style>
